import React from "react"
import { IDivider } from "../../../gatsby-graphql"
import { Divider as StyledDivider } from "./divider-elements"

interface DividerProps {
  data: IDivider
  locale?: string
}

const Divider = ({ data }: DividerProps) => {
  return (
    <StyledDivider
      marginBottom={data.marginBottom}
      marginTop={data.marginTop}
    />
  )
}

export default Divider
